import React from 'react'
import { Chip } from '@mui/material'

const statusConfig = {
  open: { label: 'Em Aberto', color: 'info' },
  processing: { label: 'Processando', color: 'secondary' },
  pending: { label: 'Pendente', color: 'warning' },
  paid: { label: 'Pago', color: 'success' },
  overdue: { label: 'Atrasado', color: 'error' },
  exemption: { label: 'Isenção', color: 'default' },
}

const TenantStatusBadge = ({ status }) => {
  const config = statusConfig[status] || { label: status, color: 'default' }

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      variant="outlined"
    />
  )
}

export default TenantStatusBadge
